import React, { useContext } from 'react';

import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';

import { DropdownContext } from './DropdownContext';

export interface DropdownElementType extends DefaultBsComponent {
  id: string;
}

export const DropdownElement = ({
  children,
  as: Component = 'div',
  id,
  className,
  ...props
}: DropdownElementType) => {
  const context = useContext(DropdownContext);

  return (
    <Component
      id={id}
      role="menuitem"
      tabIndex={0}
      className={classNames(
        'DropdownElement',
        className,
        'flex cursor-pointer min-h-[36px] min-w-[240px]',
        'max-w-[400px] block text-ellipsis overflow-hidden',
        'py-[7px] px-16 text-neutral-301 text-14',
        'hover:bg-lang-31'
      )}
      onFocus={context.changeActiveDescendant}
      onMouseOver={context.changeActiveDescendant}
      {...props}
    >
      {children}
    </Component>
  );
};
